import React from "react";
import { SERVICES } from "../mock";
import { Button } from "../components/ui/button";

export default function Services({ onStart }) {
  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-center text-4xl md:text-5xl font-extrabold text-navy mb-12">
          {SERVICES.heading}
        </h2>

        <div className="text-center mb-20">
          <p className="inline-block text-2xl md:text-3xl font-bold text-paul-yellow mb-4 border-b-2 border-paul-yellow pb-1">
            {SERVICES.title}
          </p>
          <ul className="mt-6 space-y-2 text-lg md:text-xl text-gray-500">
            {SERVICES.items.map((s) => (
              <li key={s}>- {s}</li>
            ))}
          </ul>
        </div>

        <div className="grid md:grid-cols-2 gap-12 mb-16">
          <div>
            <h3 className="text-xl md:text-2xl font-extrabold text-navy mb-3">
              {SERVICES.pillars[0].title}
            </h3>
            <p className="text-gray-600 leading-relaxed">
              {SERVICES.pillars[0].body}
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-12">
          {SERVICES.pillars.slice(1).map((p) => (
            <div key={p.title}>
              <h3 className="text-xl md:text-2xl font-extrabold text-navy mb-3">
                {p.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">{p.body}</p>
            </div>
          ))}
        </div>

        <div className="flex justify-center mt-16">
          <Button
            onClick={onStart}
            className="bg-paul-yellow hover:bg-paul-yellow text-navy font-bold px-12 py-6 text-base rounded-md shadow-md"
            style={{ color: "#0b1535" }}
          >
            Start Here
          </Button>
        </div>
      </div>
    </section>
  );
}
